import { RootState } from 'models/store';

// ==============================|| EAI SELECTORS ||============================== //

export const selectEaiCodebooks = (state: RootState) => state.eai.codebooks;

export const selectEaiServiceLevelSpecification = (state: RootState) =>
  state.eai.serviceLevelSpecifications;

export const selectEaiContextActions = (state: RootState) =>
  state.eai.contextActions;

export const selectEaiEtagList = (state: RootState) => state.eai.etag;

export const selectPermissionError = (state: RootState) =>
  state.eai.permissionError;

export const selectUserGroups = (state: RootState) => state.eai.userGroups;

export const selectShowMenu = (state: RootState) => state.eai.showMenu;

export const selectIsDeviceListReady = (state: RootState) =>
  state.eai.isReady.isDeviceListReady;

export const selectIsDeviceListForHxDashboardReady = (state: RootState) =>
  state.eai.isReady.isDeviceListForHxDashboardReady;

export const selectIsDeviceDetailListReady = (state: RootState) =>
  state.eai.isReady.isDeviceDetailListReady;

export const selectIsDeviceCharacteristicGroupListForPlanningReady = (
  state: RootState
) => state.eai.isReady.isDeviceCharacteristicGroupListForPlanningReady;
